import { deleteRecipeMutation } from '@akin-home/recipes-front-end';
import { useMutation, useQueryClient } from 'react-query';
import { recipesQueryKey } from './query_key';

export const useDeleteRecipe = () => {
  const client = useQueryClient();

  return useMutation((id: string) => deleteRecipeMutation({ input: { id } }), {
    onSuccess(_, id) {
      client.invalidateQueries(recipesQueryKey.lists());
      client.invalidateQueries(recipesQueryKey.all_pages());
      client.removeQueries(recipesQueryKey.detail(id));
    },
  });
};
